module.exports = __webpack_public_path__ + "static/img/报警.366c721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/随车吊/报警.png
// module id = 5vF/
// module chunks = 76